import {WebHelpers} from "./utils/WebHelpers";


export interface LanguageData {
    [key: string]: string; // can be string or sub-object with strings (rare)
}

export class Localizer {
    public static readonly DEFAULT_LANG = "en";

    protected webHelpers: WebHelpers;
    protected baseUrl: string = "/pub/locales/"; // + {lang}.json
    protected language: string;
    protected data: LanguageData = null;

    /**
     * Create the translation class.
     * @param language the language to load (en, de, es, ...)
     * @param baseUrl the server  to serve the {lang}.json file
     */
    constructor(webHelpers: WebHelpers, language: string, baseUrl: string = "") {
        this.webHelpers = webHelpers;
        this.language = language || Localizer.DEFAULT_LANG;
        if (baseUrl.length !== 0)
            this.baseUrl = baseUrl;
    }

    /**
     * Load the translation JSON file from server.
     */
    public async loadTranslations(): Promise<void> {
        const langUrl = `${this.baseUrl}${this.language}.json`;
        try {
            let res = await fetch(langUrl);
            this.data = await res.json();
            console.log(this.data)
        }
        catch (err) {
            console.error("Error loading translation from %s", langUrl, err);
        }
    }

    public loadTranslationsFromObject(key: string): void {
        if (typeof window[key] !== "object") {
            console.error("window.%s object to load translations doesn't exist", key);
            return;
        }
        this.data = window[key];
    }

    /**
     * Adds the tr() function to the global window object (under the specified key as function name).
     * @param key
     */
    public exportTranslationFunctionToWindow(key: string = "tr"): void {
        if (window[key] !== undefined) {
            console.error("There already exists another translation function under the same key: %s", key);
            return;
        }

        window[key] = this.get.bind(this);
    }

    /**
     * Get translation for a specific key.
     * @param key
     */
    public get(key: string): string {
        return this.data[key];
    }

    public getAll(): LanguageData {
        return this.data;
    }

    public setLang(lang: string): void {
        this.language = lang;
        this.webHelpers.setCookie("lang", lang, this.webHelpers.getConfig().cookieLifeDays);
        document.location.reload();
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

}
